"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedDateTime = _interopRequireDefault(require("I18n/components/FormattedDateTime"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _sizes = require("HubStyleTokens/sizes");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var textPath = 'ecosystemMarketplaceCore.reviews.replyThread';

var ReviewReplyThread = function ReviewReplyThread(_ref) {
  var replyMap = _ref.reply,
      onReportReplyClick = _ref.onReportReplyClick,
      TagComponent = _ref.TagComponent;

  var _replyMap$toJS = replyMap.toJS(),
      reply = _replyMap$toJS.reply,
      repliedAt = _replyMap$toJS.repliedAt,
      displayName = _replyMap$toJS.displayName,
      avatarUrl = _replyMap$toJS.avatarUrl,
      companyName = _replyMap$toJS.companyName;

  if (!reply) {
    return null;
  }

  var textKey = companyName ? 'title' : 'titleWithoutCompany';
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_HR.default, null), TagComponent && _react.default.createElement(TagComponent, null), _react.default.createElement(_UIFlex.default, {
    direction: "column",
    className: "p-left-12"
  }, _react.default.createElement(_UIFlex.default, {
    align: "center",
    className: "m-bottom-2"
  }, _react.default.createElement(_UIAvatar.default, {
    size: "xs",
    src: avatarUrl
  }), _react.default.createElement("span", {
    style: {
      fontSize: _sizes.ROOT_FONT_SIZE
    },
    className: "m-x-3"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: textPath + "." + textKey,
    options: {
      displayName: displayName,
      companyName: companyName
    }
  })), _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedDateTime.default, {
    value: repliedAt,
    format: "ll",
    type: "userTz"
  }))), _react.default.createElement(_UIFlex.default, null, reply), onReportReplyClick && _react.default.createElement(_UIButton.default, {
    use: "link",
    className: "m-top-2",
    onClick: onReportReplyClick
  }, _react.default.createElement(_FormattedMessage.default, {
    message: textPath + ".report"
  }))));
};

ReviewReplyThread.propTypes = {
  reply: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  onReportReplyClick: _propTypes.default.func,
  TagComponent: _propTypes.default.elementType
};
var _default = ReviewReplyThread;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/ReviewReplyThread.js
// module id = 287
// module chunks = 209 210 211 212